import React, { ReactElement, ReactNode, useState } from 'react'
import ClickAwayListener from '@/core/components/clickAwayListener/ClickAwayListener.tsx'
import { IconButton, Popper, Tooltip } from '@mui/material'

interface Props<T> {
  menuItem: ReactNode
  tooltip?: ReactNode
  menuPopper: ReactElement<T>
}

const MainMenuItem = <T,>({ menuItem, tooltip, menuPopper }: Props<T>) => {
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null)
  const open = Boolean(anchorEl)

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    setAnchorEl(anchorEl ? null : event.currentTarget)
  }

  const handleClickAway = () => {
    setAnchorEl(null)
  }
  return (
    <>
      <Tooltip title={tooltip}>
        <IconButton onClick={handleClick}>{menuItem}</IconButton>
      </Tooltip>
      <Popper open={open} anchorEl={anchorEl} sx={{ zIndex: '9999' }}>
        <ClickAwayListener onClickAway={handleClickAway}>
          <div onClick={handleClickAway}>{menuPopper}</div>
        </ClickAwayListener>
      </Popper>
    </>
  )
}

export default MainMenuItem
